import { Prompt } from "react-router";

interface OwnProps {
  condition: boolean | undefined;
  confirmMessage?: string;
}

type Props = OwnProps;

/** Displays a prompt when condition is `true` and user navigates to a route (via in-app navigation).
 * Handles:
 * - Clicking a <Link> or calling history.push
 * - Browser back button
 */
export function RouteNavigationGuard({
  condition,
  confirmMessage = "You have unsaved changes. Leave anyway?",
}: Props) {
  // NB: Using React router v5 Prompt.
  // In v6+ Prompt is removed so we will have to use custom solution with useBlocker.
  // https://reactrouter.com/6.30.3/upgrading/v5#prompt-is-not-currently-supported
  // https://stackoverflow.com/questions/70178993/alternative-for-prompt-in-react-router-v6/75920683#75920683
  return <Prompt when={condition} message={confirmMessage} />;
}
